const state = {
    dictionary: new Map(),
    translate: new Map(),
    reloadFlag: false,
    codeLoadingSet: new Set(),
};
const getters = {
    getOptions: state => code => {
        return state.dictionary.has(code) ? state.dictionary.get(code) : [];
    },
    translate: state => (code, value) => {
        return state.translate.get(code + '--' + value);
    }
};
const actions = {
    queryDictionary({state, dispatch}, code) {
        if (state.codeLoadingSet.has(code)) {
            return;
        }
        state.codeLoadingSet.add(code);
        dispatch('getDict', code).finally(() => state.codeLoadingSet.delete(code));
    },
    getDict({commit, dispatch}, code) {
        return new Promise((resolve, reject) => {
            dispatch('getDictOriginal', code).then(res => {
                let tempList = [];
                if (res) {
                    res.forEach(item => {
                        tempList.push({
                            value: item.id,
                            text: item.name,
                            label: item.name
                        });
                        commit('addTranslate', {
                            key: code + '--' + item.id,
                            text: item.name
                        })
                    })
                }
                resolve(tempList);
                commit('setDictionary', {
                    code: code,
                    list: tempList
                });
            }).catch(e => reject(e))
        });
    },
    getDictOriginal({dispatch}, code) {
        return new Promise((resolve, reject) => {
            dispatch(
                'api/get',
                {
                    url: process.env.VUE_APP_EM_ADMIN_URL + "/emDictData/query/" + code,
                    commonErrorHandle: false
                },
                {root: true}
            ).then(res => {
                if (!res) {
                    res = [];
                }
                resolve(res);
            }).catch(e => reject(e));
        });
    },
};
const mutations = {
    setDictionary(state, {code, list}) {
        state.dictionary.set(code, list);
        state.reloadFlag = !state.reloadFlag;
    },
    addTranslate(state, {key, text}) {
        state.translate.set(key, text);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
